import { GraviButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import type { AlertType } from '../types'
import dayjs from 'dayjs'
import { CheckCircleFilled, ExclamationCircleFilled } from '@ant-design/icons'

export type ControlPanelAlertProps = {
  alert: AlertType
  handleResolve: () => void
  children?: React.ReactNode
  icon?: React.ReactNode
  actions?: React.ReactNode
  hideButtons?: boolean
}

export function ControlPanelAlert({
  alert,
  handleResolve,
  children,
  icon,
  actions,
  hideButtons,
}: ControlPanelAlertProps) {
  const isResolved = alert.resolved_date !== null

  return (
    <Vertical
      className={`p-3 alert-card ${alert.severity}`}
      flex='none'
      height={'auto'}
      gap={8}
      style={{ overflow: 'visible' }}
    >
      <Horizontal verticalCenter>
        <div className={`alert-icon ${isResolved ? 'resolved' : alert.severity} mr-3 vertical-flex-center`}>
          {icon || <ExclamationCircleFilled />}
        </div>
        <Texto appearance={isResolved ? 'medium' : 'default'} weight='bold'>
          {alert.title}
        </Texto>
        <Texto className='flex-1' align='right' appearance='medium' category='label'>
          {dayjs(isResolved ? alert.resolved_date : alert.created_date).fromNow()}
        </Texto>
      </Horizontal>
      <Horizontal>
        <Texto appearance={isResolved ? 'medium' : 'default'} category='label'>
          {children || alert.payload?.message}
        </Texto>
      </Horizontal>
      {!isResolved && !hideButtons && (
        <Horizontal justifyContent='space-between' className='mt-2'>
          <Horizontal flex={1}>{actions}</Horizontal>
          <GraviButton theme2 onClick={handleResolve} icon={<CheckCircleFilled />} buttonText='Mark As Resolved' />
        </Horizontal>
      )}
    </Vertical>
  )
}
